import { Component, Input, OnInit } from '@angular/core';
import {
  ApplicationStepsConfiguration,
  ApplicationStepType,
} from 'src/app/+shared/components/application-steps-generic/application-steps-generic.models';

@Component({
  selector: 'app-consumption-device-steps',
  templateUrl: './consumption-device-steps.component.html',
  styleUrls: ['./consumption-device-steps.component.scss'],
})
export class ConsumptionDeviceStepsComponent implements OnInit {
  configuration: ApplicationStepsConfiguration = {
    currentStep: null,
    steps: [
      { step: ApplicationStepType.JurisdictionPage, navigateTo: 'jurisdiction' },
      { step: ApplicationStepType.TechnicalData, navigateTo: 'drr-ccd-devices/technical-data' },
      { step: ApplicationStepType.PersonalData, navigateTo: 'drr-ccd-devices/personal-data' },
      { step: ApplicationStepType.Documents, navigateTo: 'drr-ccd-devices/documents' },
    ],
  };

  @Input() set currentStep(currentStep: ApplicationStepType) {
    this.configuration.currentStep = currentStep;
  }
  @Input() disabled: boolean;

  constructor() {}

  ngOnInit(): void {}
}
